import { HStack, Skeleton, VStack } from '@chakra-ui/react';
import React from 'react';

function StatsChartPlaceholder({ height }: { height?: number }) {
  return (
    <VStack
      spacing={4}
      alignItems="start"
      position="relative"
      height={height}
      width="100%"
      borderY="2px solid gray.300"
      borderX="2px solid gray.300"
    >
      <Skeleton height="25%" width="10px" isLoaded={false} />
      <Skeleton height="25%" width="10px" isLoaded={false} />
      <Skeleton height="25%" width="10px" isLoaded={false} />
      <Skeleton height="25%" width="10px" isLoaded={false} />

      <HStack width="100%" spacing={4} position="absolute" bottom="0">
        <Skeleton height="10px" width="25%" isLoaded={false} />
        <Skeleton height="10px" width="25%" isLoaded={false} />
        <Skeleton height="10px" width="25%" isLoaded={false} />
        <Skeleton height="10px" width="25%" isLoaded={false} />
      </HStack>

      <Skeleton
        height="8px"
        width="8px"
        borderRadius="full"
        position="absolute"
        top="20%"
        left="20%"
        isLoaded={false}
      />
      <Skeleton
        height="8px"
        width="8px"
        borderRadius="full"
        position="absolute"
        top="40%"
        left="40%"
        isLoaded={false}
      />
      <Skeleton
        height="8px"
        width="8px"
        borderRadius="full"
        position="absolute"
        top="60%"
        left="60%"
        isLoaded={false}
      />
      <Skeleton
        height="8px"
        width="8px"
        borderRadius="full"
        position="absolute"
        top="80%"
        left="80%"
        isLoaded={false}
      />
    </VStack>
  );
}

export default StatsChartPlaceholder;
